import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "../components/Loader";
import { Card, CardMedia } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import { MdEdit } from "react-icons/md";
import ProductService from "../services/ProductService";
import { useBrand } from "./../helper/BrandContext";

const useStyles = makeStyles((theme) => ({
  // Your styles here
  cardMedia: {
    height: 200,
    backgroundSize: "contain"
  }
}));

const Product = ({ isLoggedIn }) => {
  const productService = new ProductService();
  const { brand } = useBrand();
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0,
    brandId: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    shippersData: []
  });
  const classes = useStyles();
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
    batchSize: "",
    UPC: "",
    Productdesc: "",
    Imgfile: ""
  });
  const [formData, setFormData] = useState({
    name: "",
    Productdesc: "",
    batchSize: "",
    UPC: "",
    Imgfile: "",
    brandId: 0,
    IsActive: true,
    brandId: 0
  });
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    ;
    if (brand) {
      tableRequest.brandId = brand;
      const storedToken = sessionStorage.getItem("token");
      setFormData((prevFormData) => ({
        ...prevFormData,
        brandId: brand
      }));
      if (storedToken) {
        isLoggedIn(true);
      } else {
        isLoggedIn(false);
        navigate("/login");
      }
      fetchProductData();
    }
  }, [isLoggedIn, navigate, brand]);

  function fetchProductData() {
    productService
      .GetProduct(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  const handleDialogOpen = (row) => {
    const editMode = () => {
      setSelectedRow(row);
      setFormData({
        id: row.id,
        name: row.name || "",
        batchSize: row.batchSize || "",
        UPC: row.upc || "",
        Productdesc: row.productdesc || "",
        Imgfile: row.productimage || "",
        brandId: row.brandId || "",
        IsActive: row.isActive || false
      });
      const previewURL = row.productimage;
      setImagePreview(previewURL);
      if (row) {
        openDialog(false); // Edit action
      } else {
        openDialog(true); // Add action
      }
    };
    return (
      <Button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2
            rounded text-sm hover:bg-blue-700 hover:text-white cursor-pointer"
        onClick={editMode}
      >
        <MdEdit />
      </Button>
    );
  };

  const imgsrc = (row) => {
    return (
      <img
        src={row.productimage}
        alt="No image"
        id="zoomA"
        style={{ width: "50px", height: "auto" }}
      />
    );
  };

  const openDialog = (isAdd) => {
    if (isAdd) {
      setShowDialog(true);
      setSelectedRow(null);
    } else {
      setShowDialog(true);
    }
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setFormErrors({
      name: "",
      batchSize: "",
      Productdesc: "",
      Imgfile: "",
      UPC: ""
    });
    setImagePreview(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setFormData({ ...formData, Imgfile: file });
    const previewURL = URL.createObjectURL(file);
    setImagePreview(previewURL);
  };

  const validateForm = (name, value) => {
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "name":
        if (value.length < 1) {
          IsValid = false;
          errors.name = "Please enter SKU name.";
        } else errors.name = "";
        break;
      case "batchSize":
        if (value.length < 1) {
          IsValid = false;
          errors.batchSize = "Please enter batch size.";
        } else errors.batchSize = "";
        break;
      case "UPC":
        if (!/^\d+$/.test(value)) {
          IsValid = false;
          errors.UPC = "Please enter a valid number for carton size.";
        } else {
          errors.UPC = "";
        }
        break;
      case "Productdesc":
        if (value.length < 1) {
          IsValid = false;
          errors.Productdesc = "Please enter product name.";
        } else errors.Productdesc = "";
        break;
      case "Imgfile":
        if (value.length < 1) {
          IsValid = false;
          errors.Imgfile = "Please select product image.";
        } else errors.Imgfile = "";
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleFormChange = (event) => {
    const { name, value, checked, type } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value
    }));
    validateForm(name, value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      if (selectedRow) {
        try {
          setState((prevData) => ({
            ...prevData,
            loading: true
          }));

          const ProductData = new FormData();
          ProductData.append("id", selectedRow.id);
          ProductData.append("name", formData.name);
          ProductData.append("batchSize", formData.batchSize);
          ProductData.append("UPC", formData.UPC);
          ProductData.append("Productdesc", formData.Productdesc);
          ProductData.append("Productimage", formData.Imgfile);
          ProductData.append("Imgfile", formData.Imgfile);
          ProductData.append("BrandId", formData.brandId);
          ProductData.append("IsActive", formData.IsActive);

          productService.CreateUpdateProduct(ProductData).then((response) => {
            setState((prevData) => ({
              ...prevData,
              loading: false
            }));
            if (response.responseCode === "200") {
              toast.success("Product Updated Successfully!");
              setFormData((prevFormData) => ({
                ...prevFormData,
                name: "",
                Productdesc: "",
                Imgfile: ""
              }));
              setSelectedRow(null);
              setShowDialog(false);
              fetchProductData();
            } else if (response.responseCode === "400") {
              toast.error(response.responseMessage);
            }
          });
        } catch (error) {
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("Product Update failed:", error);
          toast.error(error.message);
        }
      } else {
        try {
          const formDataToSend = new FormData();
          formDataToSend.append("name", formData.name);
          formDataToSend.append("batchSize", formData.batchSize);
          formDataToSend.append("UPC", formData.UPC);
          formDataToSend.append("Productdesc", formData.Productdesc);
          formDataToSend.append("Imgfile", formData.Imgfile);
          formDataToSend.append("BrandId", formData.brandId);
          formDataToSend.append("IsActive", formData.IsActive);

          productService.CreateUpdateProduct(formDataToSend).then((res) => {
            if (res.responseCode === "200") {
              // Display success message
              toast.success(res.responseMessage);
            } else {
              // Display error message
              toast.error(res.responseMessage);
            }

            handleDialogClose();
            fetchProductData();
          });
        } catch (error) {
          console.error("Error creating product:", error);
        }
      }
    }
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchProductData();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchProductData();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    fetchProductData();
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Product Master
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={openDialog}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 
                    rounded focus:outline-none focus:shadow-outline"
        >
          (+) Add Product
        </Button>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="UserMaster"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={onSort}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="name"
                    header="SKU Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="batchSize"
                    header="Batch Size"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="productdesc"
                    header="Product Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="upc"
                    header="Case Qty.UPC"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    body={imgsrc}
                    header="Product Image"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    body={handleDialogOpen}
                    header="Action"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                </DataTable>
              </div>
            </div>
          </div>

          <Dialog
            open={showDialog}
            onClose={handleDialogClose}
            PaperProps={{ style: { backgroundColor: "black" } }}
            className="add"
          >
            <DialogTitle style={{ color: "white", textAlign: "center" }}>
              {selectedRow ? "Update Product" : "Add Product"}
            </DialogTitle>
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <TextField
                  margin="dense"
                  label="Sku Name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.name}
                  helperText={formErrors.name}
                />
                <TextField
                  margin="dense"
                  label="Batch Size"
                  type="text"
                  name="batchSize"
                  value={formData.batchSize}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.batchSize}
                  helperText={formErrors.batchSize}
                />
                <TextField
                  margin="dense"
                  label="Case Qty UPC"
                  type="text"
                  name="UPC"
                  value={formData.UPC}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.UPC}
                  helperText={formErrors.UPC}
                />
                <TextField
                  margin="dense"
                  label="Product Name"
                  type="text"
                  name="Productdesc"
                  value={formData.Productdesc}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.Productdesc}
                  helperText={formErrors.Productdesc}
                />
                <div className="row justify-content-center mt-3">
                  <div className="col-md-6">
                    <input
                      accept="image/*"
                      id="product-image-input"
                      type="file"
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="product-image-input">
                      <Button
                        variant="contained"
                        component="span"
                        color="primary"
                        startIcon={<CloudUploadIcon />}
                      >
                        Upload Image
                      </Button>
                    </label>
                    {/* Image Preview */}
                    {imagePreview && (
                      <Card>
                        <CardMedia
                          className={classes.cardMedia}
                          image={imagePreview}
                          title="Uploaded Image"
                        />
                      </Card>
                    )}
                  </div>
                  <div className="col-md-6">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.IsActive}
                          onChange={handleFormChange}
                          name="IsActive"
                          color="primary"
                        />
                      }
                      label="Active"
                    />
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </div>
                </div>
              </DialogContent>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default Product;
